import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import { residenceUtility } from "../services/soar";
import ExpandDiv from "../common/ExpandDiv";
import FloatingInput from "../common/FloatingInput";

function Utilities({ data, refreshData }) {
  const [utilityData, setUtilityData] = useState({
    name: "",
    type: "",
    accountNumber: "",
    effective: "",
    expiration: "",
    active: "",
  });
  const [show, setShow] = useState(false);

  const residenceCall = async (body) => {
    const data = await residenceUtility(body);
    return data;
  };

  const saveUtility = async (obj) => {
    let body = {
      command: obj.id ? "update" : "insert",
      application: data.application,
      residence: data.id,
      name: obj.name,
      type: obj.type,
      accountNumber: obj.accountNumber,
      effective: obj.effective,
      expiration: obj.expiration,
      modifiedBy: JSON.parse(localStorage.getItem("safyInfo")).user.azureId,
    };
    if (obj.id) {
      body.id = obj.id;
    }
    const response = await residenceCall(body);
    if (response.code === "success") {
      toast.success(`Utility ${obj.id ? "Updated" : "Created"} Successfully`);
      setShow(false);
      setUtilityData({
        name: "",
        type: "",
        accountNumber: "",
        effective: "",
        expiration: "",
        active: "",
      });
      refreshData();
    } else {
      console.log("Error Response", response);
      toast.error(
        `Error ${obj.id ? "Updating" : "Creating"} Utility. ${response.message}`
      );
    }
  };

  const handleActivateDeactivate = async (utility) => {
    const body = {
      command: utility.active ? "deactivate" : "reactivate",
      application: data.application,
      id: utility.id,
      modifiedBy: JSON.parse(localStorage.getItem("safyInfo")).user.azureId,
    };
    const response = await residenceCall(body);
    if (response.code === "success") {
      toast.success(`Utility ${utility.active ? "deactivated" : "activated"}`);
      refreshData();
    } else {
      toast.error(`Error Updating Utility. ${response.message}`);
    }
  };

  return (
    <>
      <Modal
        show={show}
        onHide={() => setShow(false)}
        animation={false}
        size="lg"
      >
        <Modal.Header closeButton className="bg-safy-info text-white">
          <Modal.Title>Utility Information</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-safy2-4">
          <FloatingInput
            className="card-safy mb-2"
            label={<div className="text-danger">Name</div>}
            name="name"
            value={utilityData.name}
            onChange={(e) => {
              setUtilityData({ ...utilityData, name: e.target.value });
            }}
          />
          <FloatingInput
            className="card-safy mb-2"
            label={
              <div className="text-danger">
                Type (Gas, Electric, Water, etc)
              </div>
            }
            name="type"
            value={utilityData.type}
            onChange={(e) => {
              setUtilityData({ ...utilityData, type: e.target.value });
            }}
          />
          <FloatingInput
            className="card-safy mb-2"
            label={<div className="text-danger">Account Number</div>}
            name="effective"
            value={utilityData.accountNumber}
            onChange={(e) =>
              setUtilityData({ ...utilityData, accountNumber: e.target.value })
            }
          />
          <FloatingInput
            type="date"
            className="card-safy mb-2"
            label={<div className="text-danger">Effective Date</div>}
            name="effective"
            value={utilityData.effective}
            onChange={(e) =>
              setUtilityData({ ...utilityData, effective: e.target.value })
            }
          />
          <FloatingInput
            type="date"
            className="card-safy mb-2"
            label="Expiration Date"
            name="expiration"
            value={utilityData.expiration}
            onChange={(e) =>
              setUtilityData({ ...utilityData, expiration: e.target.value })
            }
          />
        </Modal.Body>
        <Modal.Footer className="bg-safy2-4">
          <div
            className="btn btn-sm btn-success"
            onClick={() => {
              saveUtility(utilityData);
            }}
          >
            Save
          </div>
          <div
            className="btn btn-sm btn-danger"
            onClick={() => {
              setUtilityData({
                rate: "",
                frequency: "",
                terminationNotice: "",
                effective: "",
                expiration: "",
                active: "",
              });
              setShow(false);
            }}
          >
            Cancel
          </div>
        </Modal.Footer>
      </Modal>
      <ExpandDiv
        className={`border p-2 mb-2 card-safy`}
        title="Utilities"
        expandStatus={true}
      >
        <div className="row">
          <div className="col-11"></div>
          <div className="col-1">
            <i
              className="fas fa-plus-circle fa-xl text-primary float-end me-2 mb-2"
              role="button"
              onClick={() => {
                setUtilityData({
                  id: "",
                  name: "",
                  type: "",
                  accountNumber: "",
                  effective: "",
                  expiration: "",
                  active: "",
                });
                setShow(true);
              }}
            ></i>
          </div>
        </div>
        {data.utilities
          ?.filter((l) => l.active)
          .map((utility, uindex) => (
            <div
              key={uindex}
              className="row border border-dark bg-light m-2 p-2"
            >
              <div className="col-3 fw-bold">{utility.name}</div>
              <div className="col-1 fw-bold">Type</div>
              <div className="col-2">{utility.type}</div>
              <div className="col-1 fw-bold">Account</div>
              <div className="col-2">{utility.accountNumber}</div>
              <div className="col-3">
                <i
                  className={`fas fa-${
                    utility.active ? "trash" : "times-circle"
                  } text-danger float-end mx-2`}
                  role="button"
                  onClick={() => handleActivateDeactivate(utility)}
                />
                <i
                  className="fas fa-pen text-primary float-end"
                  role="button"
                  onClick={() => {
                    setUtilityData({
                      id: utility.id,
                      name: utility.name,
                      type: utility.type,
                      accountNumber: utility.accountNumber,
                      effective: utility.effective,
                      expiration: utility.expiration,
                      active: utility.active,
                    });
                    setShow(true);
                  }}
                />
              </div>
            </div>
          ))}
      </ExpandDiv>
    </>
  );
}

export default Utilities;
